import type { AxiosInstance } from 'axios';

import type {
  CreateBlogCategoryRequest,
  UpdateBlogCategoryRequest,
  CreateBlogPostRequest,
  UpdateBlogPostRequest,
} from '@terra/contracts';

// Using unknown for the return types for now since we don't have the fully populated responses in contracts.
// We can define the response shapes if needed, but usually we just return the Prisma model type.
// For admin panel we assume basic object shape.

const unwrap = <T>(p: Promise<{ data: { data: T } }>) => p.then((r) => r.data.data);

export function blogsEndpoints(http: AxiosInstance) {
  return {
    categories: {
      list: () => unwrap<any[]>(http.get('/admin/blogs/categories')),
      create: (data: CreateBlogCategoryRequest) =>
        unwrap<any>(http.post('/admin/blogs/categories', data)),
      update: (id: string, data: UpdateBlogCategoryRequest) =>
        unwrap<any>(http.patch(`/admin/blogs/categories/${id}`, data)),
      delete: (id: string) => unwrap<any>(http.delete(`/admin/blogs/categories/${id}`)),
    },
    posts: {
      list: () => unwrap<any[]>(http.get('/admin/blogs/posts')),
      create: (data: CreateBlogPostRequest) => unwrap<any>(http.post('/admin/blogs/posts', data)),
      update: (id: string, data: UpdateBlogPostRequest) =>
        unwrap<any>(http.patch(`/admin/blogs/posts/${id}`, data)),
      delete: (id: string) => unwrap<any>(http.delete(`/admin/blogs/posts/${id}`)),
    },
  };
}
